// --------------- TYPES ---------------
import { GetUserProfile, IsSignedIn } from '../Types'

// --------------- ACTIONS ---------------

export const getUserProfile = {
  Request: (params) => ({
    type: GetUserProfile.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: GetUserProfile.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: GetUserProfile.FAILED,
    payload: error,
  }),
}

export const isSignedIn = {
  SetIsSignedIn: (data) => ({
    type: IsSignedIn.SET_IS_SIGNED_IN,
    payload: data,
  }),
}
